import { useFormikContext } from 'formik';
import { useCallback } from 'react';

import type { TeamMemberData } from '@frontend/api';
import { HStack, FormControl, FormErrorMessage } from '@frontend/components';

import { TeamMemberSelect } from 'modules/common/smartComponents/TeamMemberSelect';

import { type FormStateData } from './RulesDetailModal';

type AssigneeContainerProps = {
  isReadOnly: boolean;
};

export const AssigneeContainer = ({ isReadOnly }: AssigneeContainerProps) => {
  const { setFieldValue, getFieldProps, errors } =
    useFormikContext<FormStateData>();
  const fieldProps = getFieldProps<number | null>('defaultAssigneeId');
  const handleAssigneeChange = useCallback(
    (value: TeamMemberData | null) => {
      // If we don't get a user, we need to clear the assignee
      setFieldValue('defaultAssigneeId', value?.userId ?? null);
    },
    [setFieldValue],
  );

  return (
    <HStack
      align="stretch"
      alignItems="center"
      pr={4}
      className="assignee-add-container"
    >
      <FormControl
        isInvalid={!!errors.defaultAssigneeId}
        className="assignee-param-user"
      >
        <TeamMemberSelect
          {...fieldProps}
          disabled={!!isReadOnly}
          isClearable
          isMulti={false}
          mode="assignment"
          onChange={handleAssigneeChange}
        />
        <FormErrorMessage>{errors.defaultAssigneeId}</FormErrorMessage>
      </FormControl>
    </HStack>
  );
};
